$(document).ready(function () {
  $(document).on('click', '.mobile-header-mega-menu-list', function(e) {
    var $this = $(this);
    var $accordion = $this.next('.accordion-content');

    if ($accordion.length) {
      e.preventDefault();
      e.stopPropagation();

      if ($accordion.is(':visible')) {
        $accordion.slideUp(300);
        $this.find('.icon.icon-down').removeClass('updown-accordion-icon-show');
      } else {
        $('.accordion-content').slideUp(300);
        $('.mobile-header-mega-menu-list .icon.icon-down').removeClass('updown-accordion-icon-show');

        $accordion.slideDown(300);
        $this.find('.icon.icon-down').addClass('updown-accordion-icon-show');
      }
    }
  });

  $(document).on('click', '.menu-child-link', function(e) {
    var $this = $(this);
    var $dropdown = $this.next('.sublink-dropdown');

    if ($dropdown.length) {
      e.preventDefault();
      e.stopPropagation();

      if ($dropdown.is(':visible')) {
        $dropdown.slideUp(300);
        $this.find('.icon.icon-down').removeClass('updown-accordion-icon-show');
      } else {
        $('.sublink-dropdown').slideUp(300);
        $('.menu-child-link .icon.icon-down').removeClass('updown-accordion-icon-show');

        $dropdown.slideDown(300);
        $this.find('.icon.icon-down').addClass('updown-accordion-icon-show');
      }
    }
  });

  $(document).on('click', '.dropdown-menu-link', function(e) {
    var $this = $(this);
    var $dropdown = $this.next('.dropdownmenu');

    if ($dropdown.length) {
      e.preventDefault();
      e.stopPropagation();

      if ($dropdown.is(':visible')) {
        $dropdown.slideUp(300);
      } else {
        $('.dropdownmenu').slideUp(300);
        $dropdown.slideDown(300);
      }
    }
  });

  // $('.megamenu-item-carousel').flickity({
  //   cellAlign: 'left',
  //   contain: true,
  //   prevNextButtons: false,
  //   pageDots: false
  // });
});